/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { BakendHttpResponse } from '../bakend-http-response';

import { accessProjectsTransferOwnershipCreate } from '../fn/access-ownership/access-projects-transfer-ownership-create';
import { accessProjectsTransferOwnershipCreate$FormData } from '../fn/access-ownership/access-projects-transfer-ownership-create-form-data';
import { AccessProjectsTransferOwnershipCreate$FormData$Params } from '../fn/access-ownership/access-projects-transfer-ownership-create-form-data';
import { AccessProjectsTransferOwnershipCreate$Params } from '../fn/access-ownership/access-projects-transfer-ownership-create';
import { accessProjectsTransferOwnershipCreate$XWwwFormUrlencoded } from '../fn/access-ownership/access-projects-transfer-ownership-create-x-www-form-urlencoded';
import { AccessProjectsTransferOwnershipCreate$XWwwFormUrlencoded$Params } from '../fn/access-ownership/access-projects-transfer-ownership-create-x-www-form-urlencoded';
import { BackendTransferOwnershipDto } from '../models/backend-transfer-ownership-dto';

@Injectable({ providedIn: 'root' })
export class BackendApiAccessOwnershipService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `accessProjectsTransferOwnershipCreate()` */
  static readonly AccessProjectsTransferOwnershipCreatePath = '/api/access/projects/{project_id}/transfer-ownership/';

  /**
   * POST /projects/{id}/transfer-ownership/ {new_owner_user_id}.
   *
   * Атомарная транзакция:
   *     1. демоут текущего OWNER → ADMIN (partial unique освобождается);
   *     2. таргет → OWNER (новый OWNER);
   *     3. Project.author = таргет;
   *     4. preset/override таргета чистятся (OWNER их не имеет);
   *     5. AuditLog OWNERSHIP_TRANSFERRED;
   *     6. email обоим.
   *
   * Порядок UPDATE'ов критичен: demote сначала, иначе partial unique
   * `access_one_owner_per_project` упадёт.
   *
   * Доступ:
   *     - текущий OWNER (через ServiceAction.TRANSFER_OWNERSHIP);
   *     - superuser обходит проверку.
   *
   * Ошибки:
   *     - target не active member → 422;
   *     - target — уже OWNER → 422;
   *     - target == request.user → 422 (бессмысленно).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accessProjectsTransferOwnershipCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  accessProjectsTransferOwnershipCreate$Response(
    params: AccessProjectsTransferOwnershipCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendTransferOwnershipDto>> {
    return accessProjectsTransferOwnershipCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * POST /projects/{id}/transfer-ownership/ {new_owner_user_id}.
   *
   * Атомарная транзакция:
   *     1. демоут текущего OWNER → ADMIN (partial unique освобождается);
   *     2. таргет → OWNER (новый OWNER);
   *     3. Project.author = таргет;
   *     4. preset/override таргета чистятся (OWNER их не имеет);
   *     5. AuditLog OWNERSHIP_TRANSFERRED;
   *     6. email обоим.
   *
   * Порядок UPDATE'ов критичен: demote сначала, иначе partial unique
   * `access_one_owner_per_project` упадёт.
   *
   * Доступ:
   *     - текущий OWNER (через ServiceAction.TRANSFER_OWNERSHIP);
   *     - superuser обходит проверку.
   *
   * Ошибки:
   *     - target не active member → 422;
   *     - target — уже OWNER → 422;
   *     - target == request.user → 422 (бессмысленно).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accessProjectsTransferOwnershipCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  accessProjectsTransferOwnershipCreate(
    params: AccessProjectsTransferOwnershipCreate$Params,
    context?: HttpContext,
  ): Observable<BackendTransferOwnershipDto> {
    return this.accessProjectsTransferOwnershipCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendTransferOwnershipDto>): BackendTransferOwnershipDto => r.body),
    );
  }

  /**
   * POST /projects/{id}/transfer-ownership/ {new_owner_user_id}.
   *
   * Атомарная транзакция:
   *     1. демоут текущего OWNER → ADMIN (partial unique освобождается);
   *     2. таргет → OWNER (новый OWNER);
   *     3. Project.author = таргет;
   *     4. preset/override таргета чистятся (OWNER их не имеет);
   *     5. AuditLog OWNERSHIP_TRANSFERRED;
   *     6. email обоим.
   *
   * Порядок UPDATE'ов критичен: demote сначала, иначе partial unique
   * `access_one_owner_per_project` упадёт.
   *
   * Доступ:
   *     - текущий OWNER (через ServiceAction.TRANSFER_OWNERSHIP);
   *     - superuser обходит проверку.
   *
   * Ошибки:
   *     - target не active member → 422;
   *     - target — уже OWNER → 422;
   *     - target == request.user → 422 (бессмысленно).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accessProjectsTransferOwnershipCreate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  accessProjectsTransferOwnershipCreate$XWwwFormUrlencoded$Response(
    params: AccessProjectsTransferOwnershipCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendTransferOwnershipDto>> {
    return accessProjectsTransferOwnershipCreate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * POST /projects/{id}/transfer-ownership/ {new_owner_user_id}.
   *
   * Атомарная транзакция:
   *     1. демоут текущего OWNER → ADMIN (partial unique освобождается);
   *     2. таргет → OWNER (новый OWNER);
   *     3. Project.author = таргет;
   *     4. preset/override таргета чистятся (OWNER их не имеет);
   *     5. AuditLog OWNERSHIP_TRANSFERRED;
   *     6. email обоим.
   *
   * Порядок UPDATE'ов критичен: demote сначала, иначе partial unique
   * `access_one_owner_per_project` упадёт.
   *
   * Доступ:
   *     - текущий OWNER (через ServiceAction.TRANSFER_OWNERSHIP);
   *     - superuser обходит проверку.
   *
   * Ошибки:
   *     - target не active member → 422;
   *     - target — уже OWNER → 422;
   *     - target == request.user → 422 (бессмысленно).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accessProjectsTransferOwnershipCreate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  accessProjectsTransferOwnershipCreate$XWwwFormUrlencoded(
    params: AccessProjectsTransferOwnershipCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendTransferOwnershipDto> {
    return this.accessProjectsTransferOwnershipCreate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendTransferOwnershipDto>): BackendTransferOwnershipDto => r.body),
    );
  }

  /**
   * POST /projects/{id}/transfer-ownership/ {new_owner_user_id}.
   *
   * Атомарная транзакция:
   *     1. демоут текущего OWNER → ADMIN (partial unique освобождается);
   *     2. таргет → OWNER (новый OWNER);
   *     3. Project.author = таргет;
   *     4. preset/override таргета чистятся (OWNER их не имеет);
   *     5. AuditLog OWNERSHIP_TRANSFERRED;
   *     6. email обоим.
   *
   * Порядок UPDATE'ов критичен: demote сначала, иначе partial unique
   * `access_one_owner_per_project` упадёт.
   *
   * Доступ:
   *     - текущий OWNER (через ServiceAction.TRANSFER_OWNERSHIP);
   *     - superuser обходит проверку.
   *
   * Ошибки:
   *     - target не active member → 422;
   *     - target — уже OWNER → 422;
   *     - target == request.user → 422 (бессмысленно).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accessProjectsTransferOwnershipCreate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  accessProjectsTransferOwnershipCreate$FormData$Response(
    params: AccessProjectsTransferOwnershipCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendTransferOwnershipDto>> {
    return accessProjectsTransferOwnershipCreate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * POST /projects/{id}/transfer-ownership/ {new_owner_user_id}.
   *
   * Атомарная транзакция:
   *     1. демоут текущего OWNER → ADMIN (partial unique освобождается);
   *     2. таргет → OWNER (новый OWNER);
   *     3. Project.author = таргет;
   *     4. preset/override таргета чистятся (OWNER их не имеет);
   *     5. AuditLog OWNERSHIP_TRANSFERRED;
   *     6. email обоим.
   *
   * Порядок UPDATE'ов критичен: demote сначала, иначе partial unique
   * `access_one_owner_per_project` упадёт.
   *
   * Доступ:
   *     - текущий OWNER (через ServiceAction.TRANSFER_OWNERSHIP);
   *     - superuser обходит проверку.
   *
   * Ошибки:
   *     - target не active member → 422;
   *     - target — уже OWNER → 422;
   *     - target == request.user → 422 (бессмысленно).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accessProjectsTransferOwnershipCreate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  accessProjectsTransferOwnershipCreate$FormData(
    params: AccessProjectsTransferOwnershipCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendTransferOwnershipDto> {
    return this.accessProjectsTransferOwnershipCreate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendTransferOwnershipDto>): BackendTransferOwnershipDto => r.body),
    );
  }
}
